const initialState = {
  token: null,
  isAuthenticated: null,
  isLoading: true,
  user: null,
  errors: {},
  showWalkthroughModal: true,
};


export default function auth(state=initialState, action) {

  switch (action.type) {

    case 'USER_LOADING':
      return {...state, isLoading: true};

    case 'USER_LOADED':
      return {...state, isAuthenticated: true, isLoading: false, user: action.user};

    case 'LOGIN_SUCCESSFUL':
      return {...state, ...action.data, isAuthenticated: true, isLoading: false, errors: null};

    case 'AUTHENTICATION_ERROR':
    case 'LOGIN_FAILED':
    case 'LOGOUT_SUCCESSFUL':
      return {...state, errors: action.data, token: null, user: null,
        isAuthenticated: null, isLoading: false, showWalkthroughModal: true};
    case 'HIDE_WALKTHROUGH_MODAL':
      return {...state, showWalkthroughModal: false}

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js